// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4dde3efa","453":"b33bc066","667":"f8e08233"}[chunkId] + ".chunk.js";
};